import React, { FunctionComponent } from "react";

import AddExternalModerationPhaseContainer from "./AddExternalModerationPhaseContainer";

const AddExternalModerationPhaseRoute: FunctionComponent = () => (
  <AddExternalModerationPhaseContainer />
);

export default AddExternalModerationPhaseRoute;
